/*
 *  MediaLibraystore.js
 *
 *
 *
 */
// External dep.
import Reflux from "reflux";
// internal
import logger from "../utils/LoggerFrontend";
import Actions from "../Actions";
import { getPictureArray } from "./utils";

export default class MediaLibraryStore extends Reflux.Store {
  constructor() {
    super();

    this.state = {
      generated: [],
      keywords: [],
      keywordsLoading: false,
      licensedImage: undefined,
      loadingRecent: false,
      loadingStock: true,
      loadingStockPurchase: false,
      loadingWebsite: false,
      recent: [],
      recentLoadMore: false,
      recentLogos: [],
      requestId: "",
      stock: [],
      stockPage: 1,
      stockSearch: "",
      stockTotal: 0,
      stockKeywordsSearch: "",
      keywordsPresent: false,
      uploaded: [],
      website: []
    };

    this.listenables = Actions;
  }

  onGetHistoricImages() {
    this.setState({ loadingRecent: true });
  }

  async onGetHistoricImagesCompleted(response) {
    const { payload: pictures } = response;

    const recent = getPictureArray(pictures);
    const recentLogos = pictures?.logos || [];

    if (recent.length === 0) {
      this.setState({ recentLoadMore: false, loadingRecent: false });
      return;
    }

    this.setState({
      recent,
      recentLogos,
      loadingRecent: false
    });
  }

  onGetHistoricImagesFailed(err) {
    logger.log("error:MediaLibraryStore:onGetHistoricImagesFailed:request", err);
    this.setState({ recentLoadMore: false, loadingRecent: false });
  }

  onGetImagesFromWebsite() {
    this.setState({ loadingWebsite: true });
  }

  async onGetImagesFromWebsiteCompleted({ payload: pictures }) {
    this.setState({
      website: pictures,
      loadingWebsite: false
    });
  }

  onGetImagesFromWebsiteFailed(err) {
    logger.log("error:MediaLibraryStore:onGetImagesFromWebsiteFailed:request", "failed", err);
    this.setState({ loadingWebsite: false });
  }

  // Website and recent images
  onGetAdPreviewData() {
    this.setState({ loadingWebsite: true, loadingRecent: true });
  }

  async onGetAdPreviewDataCompleted({ payload }) {
    const { historicPictures } = payload;

    const recent = getPictureArray(historicPictures);
    const recentLogos = historicPictures?.logos || [];

    if (recent.length === 0) {
      this.setState({ recentLoadMore: false, loadingRecent: false });
      return;
    }

    this.setState({
      recent,
      recentLogos,
      loadingWebsite: false,
      loadingRecent: false
    });
  }

  onGetAdPreviewDataFailed(err) {
    logger.log("error:MediaLibraryStore:onGetAdPreviewDataFailed", "request", err);

    this.setState({
      loadingWebsite: false,
      loadingRecent: false
    });
  }

  async onGetGeneratedImagesCompleted({ payload: pictures }) {
    this.setState({ generated: pictures });
  }

  onGetGeneratedImagesFailed(err) {
    logger.log("error:MediaLibraryStore:onGetGeneratedImagesFailed", "called", err);
  }

  // Stock - search - used in both creation and edit
  onSearchShutterstockImagesAPI({ search, page = 1, keywords, defaultSearch }) {
    logger.log("MediaLibraryStore:onSearchShutterstockImagesAPI", "start searching image", {
      search,
      page,
      defaultSearch
    });

    this.setState({
      loadingStock: true,
      stockSearch: keywords ? defaultSearch : search,
      stockKeywordsSearch: keywords ? search : defaultSearch,
      keywordsPresent: keywords,
      ...(page === 1 ? { stock: [] } : {})
    });
  }

  onSearchShutterstockImagesAPICompleted({ payload }) {
    logger.log("MediaLibraryStore:onSearchShutterstockImagesAPI", "Completed", payload);
    const newImages = payload.data.map((image) => ({ ...image, searchId: payload.searchId }));

    this.setState({
      stock: payload.page > 1 ? this.state.stock.concat(newImages) : newImages,
      stockTotal: payload.total_count,
      stockPage: payload.page,
      loadingStock: false
    });
  }

  onSearchShutterstockImagesAPIFailed(err) {
    logger.log("error:MediaLibraryStore:onSearchShutterstockImagesAPI", "Failed", err);
    this.setState({ loadingStock: false });
  }

  // Stock - buy - used in editing previews for admins
  onLicenseShutterstockImageAPI({ imageIds }) {
    logger.log("MediaLibraryStore:onLicenseShutterstockImageAPI", "called", { imageIds });
    this.setState({ loadingStockPurchase: true });
  }

  onLicenseShutterstockImageAPICompleted({ payload = [] }) {
    logger.log("MediaLibraryStore:onLicenseShutterstockImageAPICompleted", "called", { payload });
    const imageUrl = Object.values(payload)[0] || "";
    this.setState({ loadingStockPurchase: false, licensedImage: imageUrl });
  }

  onLicenseShutterstockImageAPIFailed(error) {
    logger.log("error:MediaLibraryStore:onLicenseShutterstockImageAPIFailed", "called", { error });
    this.setState({ loadingStockPurchase: false });
  }

  onSaveUploadedPicture(url) {
    logger.log("MediaLibraryStore:onSaveUploadedPictureCompleted", "called", { url });
    this.setState({ uploaded: [url, ...this.state.uploaded] });
  }

  onCreateJobTitleKeywords() {
    this.setState({ keywordsLoading: true });
  }

  onCreateJobTitleKeywordsCompleted({ requestid: requestId }) {
    logger.log("MediaLibraryStore:onCreateJobTitleKeywordsCompleted", "called", { requestId });
    this.setState({ keywordsLoading: false, requestId });
  }

  onCreateJobTitleKeywordsFailed(error) {
    logger.log("error:MediaLibraryStore:onCreateJobTitleKeywordsFailed", "error", { error });
    this.setState({ keywordsStatus: false });
  }
}
